import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import Page from "components/page";
import Globalize from "globalize";
import { APP_MENU_STATE_PINNED } from "constants/menu";
import theme from "styles/theme";
import { connect } from "react-redux";

class Legacy extends PureComponent {
    static propTypes = {
        app: PropTypes.object.isRequired,
        activeBrand: PropTypes.object,
    };

    constructor() {
        super();
        this.handleManageReportingMessages = this.handleManageReportingMessages.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const routerProps = nextProps.routes[nextProps.routes.length - 1];
        this.setState({
            uri: routerProps.uri,
            subdomain: routerProps.subdomain,
        });
    }

    componentDidMount() {
        window.addEventListener("message", this.handleManageReportingMessages, false);
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleManageReportingMessages, false);
    }

    handleManageReportingMessages(event) {
        let selectedReport = this.props.location.query.selectedReport;

        const availableReports = ["customer", "orders", "products", "sales", "custom"];
        if (event.data === "LOADED_REPORTING_PAGE" && availableReports.includes(selectedReport)) {
            document.getElementById("legacy-app").contentWindow.postMessage(
                {
                    action: selectedReport,
                },
                "*",
            );
        } else if (event.data === "CLICKED_TO_BACK_BUTTON") {
            this.props.router.push(this.props.router.location.pathname.replace("reporting-legacy", "reporting"));
        }
    }

    render() {
        const { app, routes, activeBrand, location } = this.props;
        const { uri, subdomain, path } = routes[routes.length - 1];
        const style = {
            position: "fixed",
            top: "-21px",
            left: "60px",
            right: "0px",
            bottom: "0px",
            zIndex: 2,
        };

        const isEasyOrder = uri === "/easyorder/:timestamp/:ezid";
        const validUnattachedRoutes = [
            "/easyorder/:timestamp/:ezid",
            "buyer_marketplace",
            "nuorder",
            "nuorder/brand/create_new",
            "marketplace",
        ];
        const disabledAdminComponents = ["info"];
        const advancedComponents = [
            "admin/brand/vp/bulkimage",
            "admin/brand/vp/image_management",
            "admin/brand/vp/orderexportinfo",
        ];

        if (!activeBrand && !validUnattachedRoutes.includes(uri)) {
            return null;
        }

        if (app.menuState === APP_MENU_STATE_PINNED) {
            style.left = `${theme.nav.iconAndTextWidth}px`;
        }

        const base = "//" + window.location.host.replace("app.", `${subdomain}.`);

        let url;
        if (isEasyOrder) {
            url = `${base}/easyorder/${this.props.params.timestamp}/${this.props.params.ezid}`;
        } else if (validUnattachedRoutes.includes(uri)) {
            url = base + "/" + uri;
        } else {
            url = `${base}/${uri.replace(":id", activeBrand._id)}`;
        }

        if (subdomain === "admin") {
            url = `${url}${location.search}`;
            const component = location.pathname.split("admin/brand/vp/")[1];
            if (path === "admin/brand/vp/:component" || advancedComponents.includes(path)) {
                url = `${url}?vp=${component}`;
            }

            if (component && disabledAdminComponents.includes(component)) {
                return null;
            }

            if (!component && location.query && !location.query.vp) {
                // user is trying to go to legacy /admin page, redirect to new one
                this.props.router.push(`/brand/${this.props.router.params.brand}/admin/brand`);
            }
        }

        if (subdomain === "management") {
            url = `${url}${location.search}`;
            if (location.query && !location.query.vp) {
                // user is trying to go to old /management page, redirect to new one
                if (this.props.router.params.brand) {
                    this.props.router.push(`/brand/${this.props.router.params.brand}/management/nuorder`);
                } else {
                    this.props.router.push("/management/nuorder");
                }
            }
        }

        let title = "";
        switch (subdomain) {
            case "admin":
                title = Globalize.formatMessage("Admin");
                break;
            case "reporting":
                title = Globalize.formatMessage("Reporting");
                break;
            case "management":
                if (uri === "nuorder/brand/create_new") {
                    title = Globalize.formatMessage("NuORDER Utilities");
                } else {
                    title = Globalize.formatMessage("Brand Management");
                }
                break;
            case "buyer":
                title = Globalize.formatMessage("The Wall");
                break;
            case "manage":
                title = Globalize.formatMessage("Wall Settings");
                break;
            case "marketplace":
                title = Globalize.formatMessage("Find New Accounts");
                style.top = "12px";
                break;
            default:
        }

        return (
            <Page title={title} hasPageHeader={false} hasSidebar={false}>
                <div className="fixed-fullscreen" style={style}>
                    <iframe id="legacy-app" src={url} data-test="legacy-app" />
                </div>
            </Page>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeBrand: state.scope.brand,
        app: state.app,
    };
};

export default connect(mapStateToProps)(Legacy);
